import { Progress, ProgressProps } from '@chakra-ui/react';

const ProgressComponent = (props: ProgressProps) => {
  return (
    <Progress {...props} style={{...props.style, borderRadius: 12}}/>
  )
}

export { ProgressComponent as Progress, ProgressProps } 